import { render, staticRenderFns } from "./ReLeadStaffInfoMessage.vue?vue&type=template&id=7d52807b&scoped=true"
import script from "./ReLeadStaffInfoMessage.vue?vue&type=script&lang=js"
export * from "./ReLeadStaffInfoMessage.vue?vue&type=script&lang=js"
import style0 from "./ReLeadStaffInfoMessage.vue?vue&type=style&index=0&id=7d52807b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d52807b",
  null
  
)

export default component.exports